import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';
import { PLATFORM_ID, PROFICO_PLATFORM_ID } from '../constants/platform';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};
const agentService = {
  _url: process.env.REACT_APP_AGENT_API_URL,
  _model_url: process.env.REACT_APP_MODEL_API_URL,
  _feeda_url: process.env.REACT_APP_FEEDA_API_URL,
  _promopt_url: process.env.REACT_APP_PROMOT_API_URL,
  _main_url: process.env.REACT_APP_AUTH_API_URL,
  _domain_id: process.env.REACT_APP_DOMAIN_ID,
  // Prefer PLATFORM_ID at call-time below; keep property for any legacy readers
  get _platform_id() {
    return PLATFORM_ID;
  },

  GetAgentList(searchQuery, fetch) {
    const [data, setsData] = useState({
      sessions: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAllAgent(searchQuery))
        .then(res => {
          setsData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [searchQuery, fetch]);

    return {
      _loading: status === STATUS.LOADING,
      _error: status === STATUS.ERROR,
      _data: data,
    };
  },

  async createAgent(payload) {
    return await Fetch.post(`${this._url}/create`, payload);
  },
  async EditAgent(payload) {
    return await Fetch.put(`${this._url}/update`, payload);
  },
  async getAgentDetail(payload) {
    return await Fetch.get(`${this._url}/details?agent_id=${payload}&platform_id=${PLATFORM_ID}`);
  },
  async deleteAgent(payload) {
    return await Fetch.delete(`${this._url}/delete?agent_id=${payload}`);
  },
  async getAllAgent() {
    return await Fetch.get(
      `${this._url}/list?agent_type=user_created&domain_id=${this._domain_id}&platform_id=${PROFICO_PLATFORM_ID}`,
    );
  },
  async getAllModels() {
    return await Fetch.get(`${this._model_url}/list`);
  },

  async getAllfeedaAgentsCategory(domain_type) {
    const type = domain_type ? `?domain_type=${domain_type}` : ``;
    return await Fetch.get(`${this._main_url}/domain/list${type}`);
  },

  GetFeedaAgents(searchQuery, fetch) {
    const [feedaAgentData, setfeedaAgentData] = useState({
      sessions: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAllfeedaAgents(searchQuery))
        .then(res => {
          setfeedaAgentData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [searchQuery, fetch]);

    return {
      agent_loading: status === STATUS.LOADING,
      agent_error: status === STATUS.ERROR,
      agent_data: feedaAgentData,
    };
  },
  async getAllfeedaAgents(domain_id = '') {
    const domain = domain_id || this._domain_id;
    return await Fetch.get(
      `${this._url}/list?agent_type=admin_created&domain_id=${domain}&platform_id=${PROFICO_PLATFORM_ID}`,
    );
  },

  GetAllAgentsOfUser(searchQuery, fetch) {
    const [feedaAgentData, setfeedaAgentData] = useState({
      sessions: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAllAgentsOfUser(searchQuery))
        .then(res => {
          setfeedaAgentData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [searchQuery, fetch]);

    return {
      agents_loading: status === STATUS.LOADING,
      agents_error: status === STATUS.ERROR,
      agents_data: feedaAgentData,
    };
  },
  async getAllAgentsOfUser(searchQuery) {
    return await Fetch.get(`${this._url}/list?user_id=${searchQuery?.user_id}`);
  },

  async generatePrompt(payload) {
    return await Fetch.post(`${this._promopt_url}/generate?data=${payload}`);
  },
  async generateDomain(payload) {
    return await Fetch.post(`${this._main_url}/domain/create`, payload);
  },
};

export default agentService;
